import i18n from '../../../../i18n';
import lodash from 'lodash';
import { defineAsyncComponent, reactive, watch } from 'vue';
import {
    createColumnDate,
    createColumnInput,
    createColumnSelect
} from '../../../../components/table/c-table.logic';
import { createLoading } from '../../../../utils/loading';
import {
    createAppPageHeaderTop,
    createManageActive,
    createManageArchive,
    createManageDelete,
    createManageExportCsv,
    createManageSelect,
    createPage,
    createRowActionEdit,
    createRowActionView,
    onClickReport
} from '../../../../utils/page';
import {
    checkAttribute,
    initUseForm,
    onClickActive,
    onClickActiveAll,
    onClickArchive,
    onClickArchiveAll,
    onClickDelete,
    onClickDeleteAll,
    onClickEdit,
    onClickView
} from '../../../../utils/form';
import store from '../../../../store';

import {
    createFieldDate,
    createFieldInput,
    createFieldRadioGroup,
    createFieldSelect,
    createFieldTextArea
} from '../../../../components/input/template-builder/template-builder.logic';
import { has } from '../../../../utils/menu-context';
import {
    createButton,
    createButtonActive,
    createButtonArchive,
    createButtonCreate,
    createButtonDelete,
    createButtonEdit,
    createButtonSave,
    createButtonView
} from '../../../../utils/button';
import { setIsLoading as setIsLoadingApp } from '../../../../app.logic';
import { Button, Col, Modal, notification, Row } from 'ant-design-vue';
import { addRules, clearRulesStartsWith, required, requiredWhen, validateError } from '../../../../utils/validate';

import { openModalForm } from '../analysis-cross-center/analysis-cross-center.logic';
import { createForm as createFormTopic } from '../sampling-product-analysis-topic/analysis-topic.logic';
import { useForm as createUseForm } from '@ant-design-vue/use';
import { setAppPageHeader } from '../../../../components/layout/app-layout/app-layout.logic';
import { createConditionAction } from './analysis.condition';
import { flatWhereGroup } from '../../../../utils/search';
import { createConditionReport } from './analysis.report';
import { callRepeatOption } from '../physical/physical-analysis/physical-analysis.logic';

// Api
export const actionPrefix = 'resource/v1/transaction/samplingProductAnalysis';
export const { isLoading, setIsLoading } = createLoading();

export const CIcon = defineAsyncComponent(() => import('../../../../components/icon/CIcon'));

export const callSave = ({ form }) => store.dispatch(`${actionPrefix}/save`, { data: form });
export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });
export const callActive = ({ id }) => store.dispatch(`${actionPrefix}/active`, { id });
export const callArchive = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id });
export const callDelete = ({ id }) => store.dispatch(`${actionPrefix}/delete`, {
    id,
    config: { params: { isHardDelete: true } }
});
export const callActiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/activeAll`, { ids });
export const callArchiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids });
export const callDeleteAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, {
    ids,
    config: { params: { isHardDelete: true } }
});
export const callChanges = ({ id, criteria }) => store.dispatch(`${actionPrefix}/changes`, { id, criteria });
export const callLookupStatus = () => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'LAB_ANALYSIS_STATUS' });
export const callJasperReportByKey = ({ data }) => store.dispatch('resource/v1/master/jasperReport/report', { data });
export const callSearchAllLabTopicByProductIdAndCounties = ({ searchQuery, labTypeKey, productId, countryId1, countryId2, where }) => store.dispatch('resource/v1/master/labCountryStandardGroupTopicLabTopic/searchCountryStandardTopics', {
    searchQuery,
    productId,
    countryId1,
    countryId2,
    labTypeKey,
    where
});
export const callSearchAllLabTopicByMonitorProductId = ({ searchQuery, labTypeKey, productId, where }) => store.dispatch('resource/v1/master/labMonitorProductGroupTopic/searchMonitorStandardTopics', {
    searchQuery,
    productId,
    labTypeKey,
    where
});

export const callActionPerson = ({ searchQuery }) => {
    const where = [{ name: 'isActive', type: 'Boolean', operator: '=', value: true }];
    if (searchQuery) {
        where.push({ name: 'fullName', type: 'String', operator: 'like', value: searchQuery });
    }
    return store.dispatch('resource/v1/security/user/search', {
        criteria: {
            select: ['id', 'version', 'fullName'],
            page: 0,
            size: 10000,
            where,
            sort: []
        }
    }).then(page => page.data);
};


// List
export const initState = ({ props, data }) => {
    return callLookupStatus().then((status) => {
        const { menuContext, routerPrefix, refExtCenterTypeKey } = props;
        if (stateMenu[menuContext.id]) {
            return stateMenu[menuContext.id];
        }
        if (props.isSetDefaultSearchStatusByRoleMenu && data) {
            const lastPrefix = routerPrefix.split('-').pop();
            if (lastPrefix == 'all') {
                data.defaultSearchStatus = status.find(it => it.key === 'Send Result');
            } else {
                if (menuContext && has({ menuContext, key: 'canApprove' }) && refExtCenterTypeKey !== 'Lab Ext') {
                    data.defaultSearchStatus = status.find(it => it.key === 'Reviewed');
                } else if (menuContext && has({ menuContext, key: 'canReview' })) {
                    data.defaultSearchStatus = status.find(it => it.key === 'Wait');
                }
            }
        }

        const buildState = reactive({
            props,
            columns: [],
            page: createPage({
                options: {
                    select: ['*',
                        'refSamplingProduct.**',
                        'refSamplingProduct.refCompanyProduct.refProduct.*',
                        'refSamplingProduct.refSamplingMonitorProduct.**',
                        'refSamplingProduct.refSamplingRequest.refSamplingRequestType.*',
                        'refTransferFrom.refDepartment.*'
                    ],
                    sort: [{ name: 'updateDate', type: 'DESC' }]
                }
            }),
            tableOptions: { search: { activeKey: 'Search' } },
            conditionAction: createConditionAction()
        });
        buildState.columns = createColumns({ props, data });
        buildState.manages = [
            createManageSelect({ menuContext }),
            createManageActive({
                menuContext,
                onClick: ({ rowSelection }) => onClickActiveAll({
                    rowSelection,
                    callActiveAll,
                    state: buildState,
                    onSearch,
                    setIsLoading
                })
            }),
            createManageArchive({
                menuContext,
                onClick: ({ rowSelection }) => onClickArchiveAll({
                    rowSelection,
                    callArchiveAll,
                    state: buildState,
                    onSearch,
                    setIsLoading
                })
            }),
            createManageDelete({
                menuContext,
                onClick: ({ rowSelection }) => onClickDeleteAll({
                    rowSelection,
                    callDeleteAll,
                    state: buildState,
                    onSearch,
                    setIsLoading
                })
            }),
            createManageExportCsv({ menuContext })
        ];
        buildState.manageExtras = [];
        if (refExtCenterTypeKey === 'Cross Center') {
            buildState.manageExtras.push(
                {
                    visible: () => has({ menuContext, key: 'canCreate' }),
                    render: () => createButtonCreate({
                        onClick: () => openModalForm({
                            props: { ...props, setAppPageHeader: false },
                            callback: (record) => {
                                const topics = record.topics?.map(d => createFormTopic({
                                    refLabTopic: d.refLabTopic,
                                    refTransferFrom: { id: d.id },
                                    isTransfer: true
                                }));
                                const data = createForm({
                                    refLabAnalysisStatusKey: 'Wait',
                                    refSamplingProduct: { id: record.refSamplingProductAnalysis.refSamplingProduct.id },
                                    refLabType: record.refSamplingProductAnalysis.refLabType,
                                    samplingAmount: record.samplingAmount,
                                    refDepartment: record.refDepartment,
                                    refExtCenterType: record.refExtCenterType,
                                    refTransferFrom: { id: record.refSamplingProductAnalysis.id },
                                    topics: topics || []
                                });
                                setIsLoadingApp(true);
                                callSave({ form: data })
                                    .finally(() => setIsLoadingApp(false))
                                    .then(() => onSearch({ props, page: buildState.page }));
                            }
                        }),
                        isLabel: true,
                        options: {
                            text: i18n.global.t('button.createRecord')
                        }
                    })
                }
            );
        }
        buildState.rowActions = [
            createRowActionView({ menuContext, onClick: ({ record }) => onClickView({ record, routerPrefix }) }),
            createRowActionEdit({
                menuContext,
                onClick: ({ record }) => onClickEdit({ record, routerPrefix }),
                visible: ({ record }) => buildState.conditionAction.canEdit({
                    props,
                    modelRef: record,
                    initialModel: record
                })
            })
        ];
        stateMenu[menuContext.id] = buildState;
        return stateMenu[menuContext.id];
    });
};

export const onSearch = ({ props, page }) => {
    const { refLabTypeKey, refExtCenterTypeKey, refSamplingRequestTypeKey, menuContext } = props;
    const sort = page.sort || [];
    const where = page.where || [];
    setIsLoading(true);
    window.onSearch?.({ page });
    const whereFix = [
        { name: 'refLabAnalysisStatus.key', type: 'String', isNot: true, operator: '=', value: 'Draft' },
        {
            name: 'refSamplingProduct.refSamplingRequest.refSamplingRequestType.key',
            type: 'String',
            operator: 'in',
            value: refSamplingRequestTypeKey
        }
    ];
    if (refLabTypeKey) {
        whereFix.push({ name: 'refLabType.key', type: 'String', operator: '=', value: refLabTypeKey });
    }
    if (refExtCenterTypeKey) {
        whereFix.push({ name: 'refExtCenterType.key', type: 'String', operator: '=', value: refExtCenterTypeKey });
    } else {
        whereFix.push({ name: 'refExtCenterType.id', type: 'UUID', operator: '=', value: null });
    }
    return callSearch({
        criteria: {
            ...page,
            data: [],
            where: [
                ...where,
                ...whereFix,
                ...createWhereRole({ props })
            ],
            sort: sort
        }
    })
        .then(page => stateMenu[menuContext.id].page = { ...page, sort })
        .finally(() => setIsLoading(false));
};

export const createWhereRole = ({ props }) => {
    const { menuContext, refExtCenterTypeKey } = props;
    const whereGroup = [];
    const userInfo = store.state.resource.auth.info?.user;

    if (has({ menuContext, key: 'canViewAll' })) {
        return [];
    }

    if (has({ menuContext, key: 'canViewDepartment' })) {
        const whereDepartment = [
            { name: 'refDepartment.id', type: 'UUID', operator: '=', value: userInfo?.refDepartment?.id },
            {
                logic: 'OR',
                name: 'refTransferFrom.refDepartment.id',
                type: 'UUID',
                operator: '=',
                value: userInfo?.refDepartment?.id
            }
        ];
        if (['FIQC', 'FIRC'].includes(userInfo?.refDepartment?.refDepartmentType?.key)) {
            whereDepartment.push({
                logic: 'OR',
                name: 'refDepartment.refParent.id',
                type: 'UUID',
                operator: '=',
                value: userInfo?.refDepartment?.id
            });
            whereDepartment.push({
                logic: 'OR',
                name: 'refTransferFrom.refDepartment.refParent.id',
                type: 'UUID',
                operator: '=',
                value: userInfo?.refDepartment?.id
            });
        }
        whereGroup.push(whereDepartment);
    }
    if (has({ menuContext, key: 'canViewOwner' })) {
        whereGroup.push([
            { name: 'createBy', type: 'String', operator: '=', value: userInfo?.username },
            { logic: 'OR', name: 'updateBy', type: 'String', operator: '=', value: userInfo?.username }
        ]);
    }
    if (has({ menuContext, key: 'forLabExt' }) && refExtCenterTypeKey === 'Lab Ext') {
        whereGroup.push([{
            name: 'refLabExt.refUser.username',
            type: 'String',
            operator: '=',
            value: userInfo?.username
        }]);
    }
    return flatWhereGroup({ where: whereGroup, logic: 'OR' });
};

export const createColumns = ({ props, data }) => {
    const { showLabTypeKey, refExtCenterTypeKey, refLabTypeKey, refSamplingRequestTypeKey } = props;
    const columns = [
        createColumnDate({
            visible: () => props.refExtCenterTypeKey == 'Cross Center',
            title: () => i18n.global.t('model.samplingProductAnalysis.crossCenterRequestDate'),
            dataIndex: 'crossCenterRequestDate',
            width: 130,
            search: {
                field: {
                    visible: () => false
                }
            }
        }),
        // createColumnDatetime({
        //     visible: () => refSamplingRequestTypeKey?.length == 1 && refSamplingRequestTypeKey.includes("M"),
        //     title: () => i18n.global.t('model.samplingProductAnalysis.considerDatetime'),
        //     dataIndex: 'refSamplingProduct.refSamplingRequest.considerDatetime',
        //     width: 130,
        //     search: {
        //         visible: () => refSamplingRequestTypeKey?.length == 1 && refSamplingRequestTypeKey.includes("M")
        //     }
        // }),
        createColumnSelect({
            visible: () => props.refExtCenterTypeKey == 'Cross Center',
            title: () => i18n.global.t('model.samplingProductAnalysis.refTransferFrom'),
            dataIndex: 'refTransferFrom.refDepartment.nameTh',
            align: 'center',
            inputProp: () => ({
                list: ({ searchQuery }) => store.dispatch('resource/v1/master/department/cacheFindAll', {
                    searchQuery,
                    where: [{ name: 'refLabType.key', type: 'String', operator: '=', value: refLabTypeKey }]
                }),
                renderLabel: ({ item }) => <div>{item.nameTh}</div>
            }),
            search: {
                name: 'refTransferFrom.refDepartment.id',
                field: {
                    visible: () => props.refExtCenterTypeKey == 'Cross Center'
                }
            }
        }),
        createColumnSelect({
            visible: () => props.refExtCenterTypeKey == 'Cross Center',
            title: () => i18n.global.t('model.samplingProductAnalysis.transferTos'),
            dataIndex: 'refDepartment.nameTh',
            align: 'center',
            inputProp: () => ({
                list: ({ searchQuery }) => store.dispatch('resource/v1/master/department/cacheFindAll', {
                    searchQuery,
                    where: [{ name: 'refLabType.key', type: 'String', operator: '=', value: refLabTypeKey }]
                }),
                renderLabel: ({ item }) => <div>{item.nameTh}</div>
            }),
            search: {
                name: 'refDepartment.id',
                field: {
                    visible: () => props.refExtCenterTypeKey == 'Cross Center'
                }
            }
        }),
        createColumnInput({
            title: () => i18n.global.t('model.samplingProduct.samplingNo'),
            dataIndex: 'refSamplingProduct.samplingNo',
            align: 'center',
            width: 100
        }),
        createColumnSelect({
            title: () => i18n.global.t('model.samplingRequest.refSamplingRequestType'),
            dataIndex: 'refSamplingProduct.refSamplingRequest.refSamplingRequestType.value',
            align: 'center',
            inputProp: () => ({
                list: ({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', {
                    group: 'SAMPLING_CONDITION',
                    value: searchQuery
                }),
                renderLabel: ({ item }) => <div>{item.value}</div>
            }),
            search: {
                visible: () => refSamplingRequestTypeKey.length > 2,
                name: 'refSamplingProduct.refSamplingRequest.refSamplingRequestType.id'
            }
        }),
        createColumnInput({
            visible: () => showLabTypeKey || refExtCenterTypeKey === 'Lab Ext',
            title: () => i18n.global.t('model.samplingProductAnalysis.refLabType'),
            dataIndex: 'refLabType.value',
            align: 'center'
        })
    ];

    if (props.refSamplingRequestTypeKey?.includes('S') || props.refSamplingRequestTypeKey?.includes('L')) {
        columns.push(
            createColumnDate({
                title: () => i18n.global.t('model.samplingRequest.samplingCollectDate'),
                dataIndex: 'refSamplingProduct.refSamplingRequest.samplingCollectDate',
                align: 'center',
                customRender: ({ record }) => {
                    return <div>{record?.refSamplingProduct?.refSamplingRequest?.samplingCollectDate ? record?.refSamplingProduct?.refSamplingRequest?.samplingCollectDate : record?.refSamplingProduct?.refSamplingRequest?.requestDate}</div>;
                }
            }));
        columns.push(
            createColumnInput({
                title: () => i18n.global.t('model.product.code'),
                dataIndex: 'refSamplingProduct.refCompanyProduct.refProduct.code',
                customRender: ({ record }) => {
                    return <div>{record?.refSamplingProduct?.refCompanyProduct?.refProduct?.code ? record?.refSamplingProduct?.refCompanyProduct?.refProduct?.code : record?.refSamplingProduct?.refSamplingMonitorProduct?.code}</div>;
                },
                align: 'center'
            }));
        columns.push(
            createColumnInput({
                title: () => i18n.global.t('model.product.name'),
                dataIndex: 'refSamplingProduct.refCompanyProduct.refProduct.nameTh',
                align: 'center',
                customRender: ({ record }) => {
                    return <div>{record?.refSamplingProduct?.refCompanyProduct?.refProduct?.nameTh ? record?.refSamplingProduct?.refCompanyProduct?.refProduct?.nameTh : record?.refSamplingProduct?.refSamplingMonitorProduct?.name}</div>;
                }
            }));

    } else if (props.refSamplingRequestTypeKey?.includes('M')) {
        columns.push(
            createColumnDate({
                title: () => i18n.global.t('model.samplingRequest.sendLabDate'),
                dataIndex: 'refSamplingProduct.refSamplingRequest.sendLabDate',
                align: 'center',
            }),
            createColumnSelect({
                title: () => i18n.global.t('model.samplingMonitorType.modelName'),
                dataIndex: 'refSamplingProduct.refSamplingMonitorProduct.refSamplingMonitorType.name',
                customRender: ({ record }) => {
                    return <div>{record.refSamplingProduct?.refSamplingMonitorProduct?.refSamplingMonitorType?.name}</div>;
                },
                align: 'center',
                inputProp: () => ({
                    list: ({ searchQuery }) => store.dispatch('resource/v1/master/samplingMonitorType/cacheFindAll', { searchQuery })
                }),
                search: { name: 'refSamplingProduct.refSamplingMonitorProduct.refSamplingMonitorType.id' }
            }),
            createColumnSelect({
                title: () => i18n.global.t('model.samplingMonitorProduct.refSamplingMonitorSourceType'),
                dataIndex: 'refSamplingProduct.refSamplingMonitorProduct.refSamplingMonitorSourceType.value',
                align: 'center',
                inputProp: () => ({
                    list: ({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', {
                        group: 'SAMPLING_MONITOR_SOURCE_TYPE',
                        value: searchQuery
                    }),
                    renderLabel: ({ item }) => <div>{item.value}</div>
                }),
                search: { name: 'refSamplingProduct.refSamplingMonitorProduct.refSamplingMonitorSourceType.id' }
            })
        )
    }
    columns.push(
        createColumnInput({
            title: () => refSamplingRequestTypeKey.length > 2 ? i18n.global.t('model.samplingProductAnalysis.labels.samplingNameTh') + '/' + i18n.global.t('model.samplingProduct.samplingNameTh'): refSamplingRequestTypeKey.includes("M") ? i18n.global.t('model.samplingProduct.samplingNameTh'): i18n.global.t('model.samplingProductAnalysis.labels.samplingNameTh'),
            dataIndex: 'refSamplingProduct.samplingNameTh',
            align: 'center',
            customRender: ({ record }) => {
                return <div>{record?.refSamplingProduct?.samplingNameTh}</div>;
            }
        }));
    columns.push(
        createColumnSelect({
            title: () => i18n.global.t('model.samplingProductAnalysis.refLabAnalysisStatus'),
            dataIndex: 'refLabAnalysisStatus.value',
            align: 'center',
            inputProp: () => ({
                list: ({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', {
                    group: 'LAB_ANALYSIS_STATUS',
                    value: searchQuery
                }),
                renderLabel: ({ item }) => <div>{item.value}</div>
            }),
            search: {
                name: 'refLabAnalysisStatus.id',
                field: {
                    searchValue: data.defaultSearchStatus
                }
            }
        }));
    return columns;
};

// Form
export const createFormTitle = ({ data }) => {
    return data.useForm?.modelRef?.id ?
        `${data.useForm.modelRef.refSamplingProduct?.samplingNo} (${data.useForm.modelRef.refLabAnalysisStatus?.value || ''})`
        : i18n.global.t('button.create');
};

export const createSearchOneCriteria = ({ id, forLog }) => {
    if (!forLog) {
        return {
            page: 0, size: 1,
            select: [
                '**',
                'refDepartment.**',
                'refNetWeightUnit.**',
                'refNetVolumeUnit.**',
                'refDrainWeightUnit.**',
                'refSamplingProduct.**',
                'refSamplingProduct.refDepartment.refProvince.*',
                'refSamplingProduct.refDepartment.refLabType.*',
                'refSamplingProduct.refCompanyProduct.refProduct.*',
                'refSamplingProduct.refCompanyProduct.refProduct.refProductType.*',
                'refSamplingProduct.refSamplingMonitorProduct.**',
                'refSamplingProduct.refSamplingRequest.*',
                'refSamplingProduct.refSamplingRequest.refSamplingRequestType.*'
            ],
            where: [{ name: 'id', type: 'UUID', operator: '=', value: id }]
        };
    } else {
        return {
            select: [],
            page: 0,
            size: 1,
            where: [{ name: 'id', type: 'UUID', operator: '=', value: id }],
            children: []
        };
    }
};

export const createForm = (form = {}) => {
    return {
        refSamplingProduct: null,
        refLabType: null,
        samplingReceiveDate: null,
        analysisStartDate: null,
        analysisEndDate: null,
        reviewDate: null,
        approveDate: null,
        crossCenterRequestDate: null,
        refReviewer: null,
        refAuditor: null,
        remark: null,
        refDepartment: null,
        refLabExt: null,
        refTransferFrom: null,
        isAccepted: null,
        refLabAnalysisStatus: null,
        refLabResultStatus: null,
        rejectRemark: null,
        netWeight: null,
        drainWeight: null,
        samplingAmount: null,
        amount: null,
        transferTos: null,
        topics: [],
        attachments: [],
        isActive: true,
        ...form
    };
};

export const createRules = (rules = {}) => {
    return {
        refSamplingProduct: [],
        refLabType: [],
        samplingReceiveDate: [],
        analysisStartDate: [],
        reviewDate: [],
        approveDate: [],
        crossCenterRequestDate: [],
        refReviewer: [],
        refAuditor: [],
        remark: [],
        refDepartment: [],
        refLabExt: [],
        refTransferFrom: [],
        isAccepted: [],
        refLabAnalysisStatus: [],
        refLabResultStatus: [],
        rejectRemark: [],
        netWeight: [],
        drainWeight: [],
        samplingAmount: [],
        amount: [],
        transferTos: [],
        topics: [],
        attachments: [],
        ...rules
    };
};

export const createFields = ({ data /*props, refSamplingRequestType*/ }) => {
    const { useForm } = data;
    const { modelRef } = useForm;
    // const refSamplingRequestTypeKey = refSamplingRequestType?.key ? [refSamplingRequestType?.key] : props.refSamplingRequestTypeKey;
    const fields = [
        createFieldInput({
            key: `refSamplingProduct.refSamplingRequestType.value`,
            colProp: () => ({ xs: 24, md: 8 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 11 }, wrapperCol: { xs: 24, md: 13 } }),
            label: () => i18n.global.t('model.samplingRequest.refSamplingRequestType'),
            inputProp: () => ({
                value: modelRef.refSamplingProduct?.refSamplingRequest?.refSamplingRequestType.value,
                'onUpdate:value': value => modelRef.refSamplingProduct.refSamplingRequestType = value,
                disabled: true
            })
        }),
        createFieldInput({
            key: `refSamplingProduct.refSamplingType`,
            colProp: () => ({ xs: 24, md: 8 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 11 }, wrapperCol: { xs: 24, md: 13 } }),
            label: () => i18n.global.t('model.samplingProduct.samplingNo'),
            inputProp: () => ({
                value: modelRef.refSamplingProduct?.samplingNo,
                'onUpdate:value': value => modelRef.refSamplingProduct.samplingNo = value,
                disabled: true
            })
        })
    ];
    // if (refSamplingRequestTypeKey?.includes('S') || refSamplingRequestTypeKey?.includes('L')) {
    fields.push(createFieldInput({
        visible: () => modelRef.refSamplingProduct?.refSamplingRequest?.refSamplingRequestType?.key != 'M',
        key: `refSamplingProduct.refCompanyProduct.refProduct.refProductType.value`,
        colProp: () => ({ xs: 24, md: 8 }),
        formItemProp: () => ({ labelCol: { xs: 24, md: 11 }, wrapperCol: { xs: 24, md: 13 } }),
        label: () => i18n.global.t('model.lookup.modelGroup.PRODUCT_TYPE'),
        inputProp: () => ({
            value: modelRef.refSamplingProduct?.refCompanyProduct?.refProduct?.refProductType?.value,
            disabled: true
        }),
        changeLog: { getValue: ({ record }) => record.refSamplingProduct?.refCompanyProduct?.refProduct?.refProductType?.value }
    }));
    fields.push(createFieldInput({
        visible: () => true,
        key: `refSamplingProduct.refCountry1`,
        colProp: () => ({ xs: 24, md: 8 }),
        formItemProp: () => ({ labelCol: { xs: 24, md: 11 }, wrapperCol: { xs: 24, md: 13 } }),
        label: () => i18n.global.t('model.samplingProduct.exportCountry'),
        inputProp: () => ({
            value: `${modelRef.refSamplingProduct?.refCountry1?.nameEn}${!modelRef.refSamplingProduct?.refCountry2 ? '' : `, ${modelRef.refSamplingProduct?.refCountry2?.nameEn}`}`,
            disabled: true
        }),
        changeLog: {
            getValue: ({ record }) => {
                let text = record.refSamplingProduct?.refCountry1?.nameEn;
                const refCountry2NameEn = record.refSamplingProduct?.refCountry2?.nameEn;
                if (refCountry2NameEn && text) {
                    text += `, ${refCountry2NameEn}`;
                }
                return text;
            }
        }
    }));
    fields.push(createFieldDate({
        visible: () => modelRef.refSamplingProduct?.refSamplingRequest?.refSamplingRequestType?.key != 'M',
        key: `refSamplingProduct.refSamplingRequest.samplingCollectDate`,
        colProp: () => ({ xs: 24, md: 8 }),
        formItemProp: () => ({ labelCol: { xs: 24, md: 11 }, wrapperCol: { xs: 24, md: 13 } }),
        label: () => i18n.global.t('model.samplingRequest.samplingCollectDate'),
        inputProp: () => ({
            value: modelRef.refSamplingProduct?.refSamplingRequest?.samplingCollectDate,
            disabled: true
        })
    }));
    // createFieldInput({
    //     key: `refSamplingProduct.refSamplingRequest.refSamplingRequestType.value`,
    //     colProp: () => ({ xs: 24, md: 8 }),
    //     formItemProp: () => ({ labelCol: { xs: 24, md: 11 }, wrapperCol: { xs: 24, md: 13 } }),
    //     label: () => i18n.global.t('model.lookup.modelGroup.SAMPLING_CONDITION_V2'),
    //     inputProp: () => {
    //         const refSamplingRequestType = modelRef.refSamplingProduct?.refSamplingRequest?.refSamplingRequestType;
    //         return {
    //             value: `${refSamplingRequestType?.value} (${refSamplingRequestType?.valueEn})`,
    //             disabled: true
    //         };
    //     }
    // }),
    fields.push(createFieldInput({
        visible: () => modelRef.refSamplingProduct?.refSamplingRequest?.refSamplingRequestType?.key != 'M',
        key: `refSamplingProduct.size`,
        colProp: () => ({ xs: 24, md: 8 }),
        formItemProp: () => ({ labelCol: { xs: 24, md: 11 }, wrapperCol: { xs: 24, md: 13 } }),
        label: () => i18n.global.t('model.samplingProduct.size'),
        inputProp: () => ({ value: modelRef.refSamplingProduct?.size, disabled: true })
    }));
    fields.push(createFieldInput({
        visible: () => modelRef.refSamplingProduct?.refSamplingRequest?.refSamplingRequestType?.key != 'M',
        key: `refSamplingProduct.refCompanyProduct.refProduct.code`,
        colProp: () => ({ xs: 24, md: 8 }),
        formItemProp: () => ({ labelCol: { xs: 24, md: 11 }, wrapperCol: { xs: 24, md: 13 } }),
        label: () => i18n.global.t('model.product.code'),
        inputProp: () => ({
            value: modelRef.refSamplingProduct?.refCompanyProduct?.refProduct?.code,
            disabled: true
        })
    }));
    fields.push(createFieldInput({
        visible: () => modelRef.refSamplingProduct?.refSamplingRequest?.refSamplingRequestType?.key != 'M',
        key: `refSamplingProduct.refCompanyProduct.refProduct.name`,
        colProp: () => ({ xs: 24, md: 8 }),
        formItemProp: () => ({ labelCol: { xs: 24, md: 11 }, wrapperCol: { xs: 24, md: 13 } }),
        label: () => i18n.global.t('model.product.modelName'),
        inputProp: () => ({
            value: modelRef.refSamplingProduct?.refCompanyProduct?.refProduct?.nameTh,
            disabled: true
        })
    }));
    fields.push(createFieldInput({
        visible: () => modelRef.refSamplingProduct?.refSamplingRequest?.refSamplingRequestType?.key != 'M',
        key: `refSamplingProduct.packageSize`,
        colProp: () => ({ xs: 24, md: 8 }),
        formItemProp: () => ({ labelCol: { xs: 24, md: 11 }, wrapperCol: { xs: 24, md: 13 } }),
        label: () => i18n.global.t('model.samplingProduct.packageSize'),
        inputProp: () => ({ value: modelRef.refSamplingProduct?.packageSize, disabled: true })
    }));
    // } else if (refSamplingRequestTypeKey?.includes('M')) {
    fields.push(createFieldInput({
        visible: () => true,
        key: `samplingNameTh.`,
        colProp: () => ({ xs: 24, md: 8 }),
        formItemProp: () => ({ labelCol: { xs: 24, md: 11 }, wrapperCol: { xs: 24, md: 13 } }),
        label: () => modelRef.refSamplingProduct?.refSamplingRequest?.refSamplingRequestType?.key != 'M' ?i18n.global.t('model.samplingProductAnalysis.labels.samplingNameTh')  : i18n.global.t('model.samplingProduct.samplingNameTh'),
        inputProp: () => ({
            value: modelRef.refSamplingProduct?.samplingNameTh,
            disabled: true
        })
    }));
    fields.push(createFieldInput({
        visible: () => modelRef.refSamplingProduct?.refSamplingRequest?.refSamplingRequestType?.key == 'M',
        key: `refSamplingMonitorSpecies.`,
        colProp: () => ({ xs: 24, md: 8 }),
        formItemProp: () => ({ labelCol: { xs: 24, md: 11 }, wrapperCol: { xs: 24, md: 13 } }),
        label: () => i18n.global.t('model.samplingProduct.refSamplingMonitorSpecies'),
        inputProp: () => {
            const refSamplingMonitorSpecies = modelRef.refSamplingProduct?.refSamplingMonitorProduct?.refSamplingMonitorSpecies;
            return {
                value: `${refSamplingMonitorSpecies?.code} - ${refSamplingMonitorSpecies?.name}`,
                disabled: true
            };
        }
    }));
    fields.push(createFieldInput({
        visible: () => modelRef.refSamplingProduct?.refSamplingRequest?.refSamplingRequestType?.key == 'M',
        key: `refSamplingMonitorSourceType.`,
        colProp: () => ({ xs: 24, md: 8 }),
        formItemProp: () => ({ labelCol: { xs: 24, md: 11 }, wrapperCol: { xs: 24, md: 13 } }),
        label: () => i18n.global.t('model.samplingMonitorProduct.refSamplingMonitorSourceType'),
        inputProp: () => {
            const refSamplingMonitorSourceType = modelRef.refSamplingProduct?.refSamplingMonitorProduct?.refSamplingMonitorSourceType;
            return {
                value: `${refSamplingMonitorSourceType?.key} - ${refSamplingMonitorSourceType?.value}`,
                disabled: true
            };
        }
    }));
    fields.push(createFieldInput({
        visible: () => modelRef.refSamplingProduct?.refSamplingRequest?.refSamplingRequestType?.key == 'M',
        key: `refSamplingMonitorType.`,
        colProp: () => ({ xs: 24, md: 8 }),
        formItemProp: () => ({ labelCol: { xs: 24, md: 11 }, wrapperCol: { xs: 24, md: 13 } }),
        label: () => i18n.global.t('model.samplingProduct.refSamplingMonitorType'),
        inputProp: () => {
            const refSamplingMonitorType = modelRef.refSamplingProduct?.refSamplingMonitorProduct?.refSamplingMonitorType;
            return {
                value: `${refSamplingMonitorType?.code} - ${refSamplingMonitorType?.name}`,
                disabled: true
            };
        }
    }));
    fields.push(createFieldDate({
        visible: () => modelRef.refSamplingProduct?.refSamplingRequest?.refSamplingRequestType?.key == 'M',
        key: `refSamplingProduct.refSamplingRequest.requestDate`,
        colProp: () => ({ xs: 24, md: 8 }),
        formItemProp: () => ({ labelCol: { xs: 24, md: 11 }, wrapperCol: { xs: 24, md: 13 } }),
        label: () => i18n.global.t('model.samplingRequest.requestDate'),
        inputProp: () => {
            return {
                value: modelRef.refSamplingProduct?.refSamplingRequest?.requestDate,
                disabled: true
            };
    }
    }));
    fields.push(createFieldInput({
            visible: () => modelRef.refSamplingProduct?.refSamplingRequest?.refSamplingRequestType?.key == 'M' && !['A','B','C','D','E','F','G'].includes(modelRef.refSamplingProduct?.refSamplingMonitorProduct?.refSamplingMonitorType?.code),
            key: `refSamplingProduct.factoryName`,
            colProp: () => ({ xs: 24, md: 8 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 11 }, wrapperCol: { xs: 24, md: 13 } }),
            label: () => i18n.global.t('model.samplingProduct.factoryName'),
            inputProp: () => {
                return {
                    value: modelRef.refSamplingProduct?.factoryName,
                    disabled: true
                };
            }
    }))
    fields.push(createFieldInput({
        visible: () => modelRef.refSamplingProduct?.refSamplingRequest?.refSamplingRequestType?.key == 'M' && !['A','B','C','D','E','F','G'].includes(modelRef.refSamplingProduct?.refSamplingMonitorProduct?.refSamplingMonitorType?.code),
        key: `refSamplingProduct.refCountry1`,
        colProp: () => ({ xs: 24, md: 8 }),
        formItemProp: () => ({ labelCol: { xs: 24, md: 11 }, wrapperCol: { xs: 24, md: 13 } }),
        label: () => i18n.global.t('model.samplingProduct.exportCountry'),
        inputProp: () => {
            return {
                value: modelRef.refSamplingProduct?.refCountry1?.nameTh,
                disabled: true
            };
        }
    }))
    fields.push(createFieldInput({
        visible: () => modelRef.refSamplingProduct?.refSamplingRequest?.refSamplingRequestType?.key == 'M' && !['A','B','C','D','E','F','G'].includes(modelRef.refSamplingProduct?.refSamplingMonitorProduct?.refSamplingMonitorType?.code),
        key: `refSamplingProduct.size`,
        colProp: () => ({ xs: 24, md: 8 }),
        formItemProp: () => ({ labelCol: { xs: 24, md: 11 }, wrapperCol: { xs: 24, md: 13 } }),
        label: () => i18n.global.t('model.samplingProduct.size'),
        inputProp: () => {
            return {
                value: modelRef.refSamplingProduct?.size,
                disabled: true
            };
        }
    }))

    // }
    return fields;
};

export const createFieldsAnalysis = ({ props, data }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    return [
        createFieldDate({
            key: `samplingReceiveDate`,
            colProp: () => ({ xs: 24, md: 8 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
            label: () => i18n.global.t('model.samplingProductAnalysis.samplingReceiveDate'),
            inputProp: () => ({
                value: modelRef.samplingReceiveDate,
                'onUpdate:value': value => modelRef.samplingReceiveDate = value,
                disabled: viewOnly
            })
        }),
        createFieldDate({
            key: `analysisStartDate`,
            colProp: () => ({ xs: 24, md: 8 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
            label: () => i18n.global.t('model.samplingProductAnalysis.analysisStartDate'),
            inputProp: () => ({
                value: modelRef.analysisStartDate,
                'onUpdate:value': value => modelRef.analysisStartDate = value,
                disabled: viewOnly
            })
        }),
        createFieldDate({
            visible: () => props.refExtCenterTypeKey == 'Lab Ext',
            key: `analysisEndDate`,
            colProp: () => ({ xs: 24, md: 8 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
            label: () => i18n.global.t('model.samplingProductAnalysis.analysisEndDate'),
            inputProp: () => ({
                value: modelRef.analysisEndDate,
                'onUpdate:value': value => modelRef.analysisEndDate = value,
                disabled: viewOnly
            })
        }),
        {
            visible: () => true,
            colProp: () => ({ md: 8 }),
            formItemRender: () => {
            }
        },
        createFieldSelect({
            visible: () => modelRef.refReviewer != null,
            key: `refReviewer.fullName`,
            colProp: () => ({ xs: 24, md: 8 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
            label: () => i18n.global.t('model.samplingProductAnalysis.refReviewer'),
            inputProp: () => ({
                value: modelRef.refReviewer,
                'onUpdate:value': value => modelRef.refReviewer = value,
                list: callActionPerson,
                optLabel: 'fullName',
                disabled: true
            })
        }),

        createFieldDate({
            visible: () => modelRef.reviewDate != null,
            key: `reviewDate`,
            colProp: () => ({ xs: 24, md: 8 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
            label: () => i18n.global.t('model.samplingProductAnalysis.reviewDate'),
            inputProp: () => ({
                value: modelRef.reviewDate,
                'onUpdate:value': value => modelRef.reviewDate = value,
                disabled: true
            })
        }),
        {
            visible: () => true,
            colProp: () => ({ md: 8 }),
            formItemRender: () => {
            }
        },
        createFieldSelect({
            visible: () => modelRef.refAuditor != null,
            key: `refAuditor.fullName`,
            colProp: () => ({ xs: 24, md: 8 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
            label: () => i18n.global.t('model.samplingProductAnalysis.refAuditor'),
            inputProp: () => ({
                value: modelRef.refAuditor,
                'onUpdate:value': value => modelRef.refAuditor = value,
                list: callActionPerson,
                optLabel: 'fullName',
                disabled: true
            })
        }),
        createFieldDate({
            visible: () => modelRef.approveDate != null,
            key: `approveDate`,
            colProp: () => ({ xs: 24, md: 8 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
            label: () => i18n.global.t('model.samplingProductAnalysis.approveDate'),
            inputProp: () => ({
                value: modelRef.approveDate,
                'onUpdate:value': value => modelRef.approveDate = value,
                disabled: true
            })
        }),
        {
            visible: () => true,
            colProp: () => ({ xs: 24 }),
            formItemRender: () => {
            }
        }
    ];
};

export const fieldsAnalysisRemark = ({ props, data }) => {
    const { viewOnly, refExtCenterTypeKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    return [
        createFieldInput({
            visible: () => viewOnly && !refExtCenterTypeKey,
            key: `refLabResultStatus`,
            colProp: () => ({ xs: 24, md: 16 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 8 } }),
            label: () => i18n.global.t('model.samplingProductAnalysis.refLabResultStatus'),
            inputProp: () => ({ value: modelRef.refLabResultStatus?.value, disabled: true })
        }),
        createFieldRadioGroup({
            visible: () => !viewOnly && !refExtCenterTypeKey,
            key: 'refLabResultStatus',
            colProp: () => ({ xs: 24, md: 16 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            label: () => i18n.global.t('model.samplingProductAnalysis.refLabAnalysisStatus'),
            inputProp: () => {
                return {
                    value: modelRef.refLabResultStatus, // refLabAnalysisStatusEntry
                    'onUpdate:value': value => {
                        modelRef.refLabResultStatus = value;
                    },
                    disabled: viewOnly,
                    list: () => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'ACCEPT_STATUS' }).then(list => {
                        const requestTypeKey = modelRef?.refSamplingProduct?.refSamplingRequest?.refSamplingRequestType?.key;
                        return list?.filter((it) => {
                            if (requestTypeKey == 'M' && it.key == 'RejectCanRepeat') {
                                return false;
                            }
                            return true;
                        });
                    }),
                    renderLabel: ({ item }) => <span>{item?.value}</span>
                };
            }
        }),
        createFieldTextArea({
            visible: () => ['Reject', 'RejectCanRepeat'].includes(modelRef.refLabResultStatus?.key),
            key: `rejectRemark`,
            colProp: () => ({ xs: 24, md: 16 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            label: () => i18n.global.t('model.samplingProductAnalysis.rejectRemark'),
            inputProp: () => (lodash.merge({
                value: modelRef.rejectRemark,
                'onUpdate:value': value => modelRef.rejectRemark = value,
                disabled: viewOnly
            }))
        }),
        createFieldTextArea({
            key: `remark`,
            colProp: () => ({ xs: 24, md: 16 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            label: () => i18n.global.t('model.samplingProductAnalysis.remark'),
            inputProp: () => (lodash.merge({
                value: modelRef.remark,
                'onUpdate:value': value => modelRef.remark = value,
                disabled: viewOnly
            }))
        })
    ];
};

export const createActionButtons = ({ data }) => {
    const { useForm } = data;
    const { modelRef } = useForm;
    return [
        {
            visible: () => true,
            formItemRender: () => {
                const buttonTitle = i18n.global.t('model.samplingProductAnalysis.buttons.testReport');
                return <Button class="btn-primary m-2" size="small"
                               onClick={() => {
                                   const report = state.conditionReport.testReport({ modelRef });
                                   onClickReport({
                                       fileName: 'test_report.pdf',
                                       callReport: () => {
                                           return callJasperReportByKey({
                                               data: {
                                                   ...report,
                                                   attribute: { id: data.id }
                                               }
                                           });
                                       }
                                   });
                               }}>
                    <span>{buttonTitle}</span>
                    <CIcon file={'report.svg'}></CIcon>
                </Button>;
            }
        },
        {
            visible: () => modelRef.refLabResultStatus?.key == 'RejectCanRepeat',
            formItemRender: () => {
                const buttonTitle = i18n.global.t('model.samplingProductAnalysis.buttons.suspendReport');
                return <Button class="btn-warning m-2" size="small"
                               onClick={() => {
                                   const report = state.conditionReport.suspendForm({ modelRef });
                                   onClickReport({
                                       fileName: 'suspend_form.pdf',
                                       callReport: () => callJasperReportByKey({
                                           data: {
                                               ...report,
                                               attribute: { id: data.id }
                                           }
                                       })
                                   });
                               }}>
                    <span>{buttonTitle}</span>
                    <CIcon file={'report.svg'}></CIcon>
                </Button>;
            }
        },
        {
            visible: () => modelRef.refLabResultStatus?.key == 'Reject',
            formItemRender: () => {
                const buttonTitle = i18n.global.t('model.samplingProductAnalysis.buttons.rejectReport');
                return <Button class="btn-danger m-2" size="small"
                               onClick={() => {
                                   const report = state.conditionReport.rejectionForm({ modelRef });
                                   onClickReport({
                                       fileName: 'reject_form.pdf',
                                       callReport: () => callJasperReportByKey({
                                           data: {
                                               ...report,
                                               attribute: { id: data.id }
                                           }
                                       })
                                   });
                               }}> <span>{buttonTitle}</span>
                    <CIcon file={'report.svg'}></CIcon>
                </Button>;
            }
        }
    ];
};

export const createAppPageHeaderDefault = ({ props, data }) => {
    const col1 = [];
    const col2 = [];
    const { menuContext, viewOnly, routerPrefix, refExtCenterTypeKey } = props;
    const { useForm } = data;
    const { modelRef, initialModel } = useForm;
    const { id, isActive } = modelRef;
    const canEdit = stateMenu[menuContext.id]?.conditionAction?.canEdit({ props, modelRef, initialModel });
    const canCalculate = stateMenu[menuContext.id]?.conditionAction?.canCalculate({ props, modelRef, initialModel });
    const canReview = stateMenu[menuContext.id]?.conditionAction?.canReview({ props, modelRef, initialModel });
    const canApprove = stateMenu[menuContext.id]?.conditionAction?.canApprove({ props, modelRef, initialModel });

    if (!viewOnly && id && has({ menuContext, key: 'canView' })) {
        col1.push(createButtonView({
            onClick: () => onClickView({ record: { id }, routerPrefix }),
            classStyle: 'm-1'
        }));
    }
    if (viewOnly && id && isActive && canEdit) {
        col1.push(createButtonEdit({
            onClick: () => onClickEdit({ record: { id }, routerPrefix }),
            classStyle: 'm-1'
        }));
    }
    if (!viewOnly && (!id || (id && isActive)) && canEdit) {
        col1.push(createButtonSave({
            onClick: () => {
                lodash.set(data, 'isValidateForm', false);
                onClickSave({ props, data });
            }, classStyle: 'm-1'
        }));
    }

    if (id && isActive) {
        if (!refExtCenterTypeKey && (canCalculate)) {
            col1.push(createButton({
                text: `${viewOnly ? '' : `${i18n.global.t('button.save')} & `}${i18n.global.t('model.samplingProductAnalysis.labels.calculate')}`,
                classStyle: `m-1 btn-warning`,
                onClick: () => {
                    onClickSave({ props, data, form: { isCalculate: true, isIssueTestReport: true } });
                },
                icon: <CIcon file='save.svg'></CIcon>,
                confirm: {}
            }));
        }

        if (viewOnly && canReview) {
            col1.push(createButton({
                text: `${viewOnly ? '' : `${i18n.global.t('button.save')} & `}${i18n.global.t('model.samplingProductAnalysis.labels.review')}`,
                classStyle: `m-1 btn-primary`,
                onClick: () => {
                    lodash.set(data, 'isValidateForm', true);
                    Promise.all([
                        addRules({ useForm, modelRef, key: 'samplingReceiveDate', rules: [required] }),
                        addRules({ useForm, modelRef, key: 'analysisStartDate', rules: [required] }),
                        addRules({
                            useForm,
                            modelRef,
                            key: 'analysisEndDate',
                            rules: [[requiredWhen({ when: () => refExtCenterTypeKey === 'Cross Center' })]]
                        })
                    ]).then(
                        () => {
                            const refLabAnalysisStatus = data.statuses?.find(d => d.key === 'Reviewed');
                            const isIssueTestReport = modelRef.refDepartment?.refLabType?.key == 'labPhysic' || modelRef?.refTransferFrom != null ? true : false;
                            onClickSave({
                                props,
                                data,
                                form: { refLabAnalysisStatus, isIssueTestReport: isIssueTestReport }
                            });
                        }
                    );
                },
                icon: <CIcon file='save.svg'></CIcon>,
                confirm: {}
            }));
        }

        if (canApprove) {
            col1.push(createButton({
                text: `${viewOnly ? '' : `${i18n.global.t('button.save')} & `}${i18n.global.t('model.samplingProductAnalysis.labels.approve')}`,
                classStyle: `m-1 btn-primary`,
                onClick: () => {
                    lodash.set(data, 'isValidateForm', true);
                    const promise = [];
                    const canApprove = stateMenu[menuContext.id].conditionAction.canApprove({
                        props,
                        modelRef,
                        initialModel
                    });
                    if (initialModel?.refLabAnalysisStatus?.key === 'Reviewed' && canApprove) {
                        if (!refExtCenterTypeKey) {
                            promise.push(addRules({ useForm, modelRef, key: `refLabResultStatus`, rules: [required] }));
                        } else if (refExtCenterTypeKey === 'Lab Ext') {
                            const attachments = modelRef?.attachments?.filter(d => !d.isDelete) || [];
                            if (attachments.length === 0) {
                                notification['error']({ message: i18n.global.t('model.samplingProductAnalysis.labels.requireAttachment') });
                                return;
                            }
                        }
                    }
                    Promise.all(promise).then(
                        () => {
                            const refLabAnalysisStatus = data.statuses.find(d => d.key === 'Send Result');
                            onClickSave({ props, data, form: { refLabAnalysisStatus } });
                        }
                    );

                },
                icon: <CIcon file='resource.svg'></CIcon>,
                confirm: {}
            }));
        }
    }

    if (viewOnly && id && !isActive && has({ menuContext, key: 'canActive' })) {
        col2.push(createButtonActive({
            onClick: () => onClickActive({
                record: { id },
                callActive,
                setIsLoading: setIsLoadingApp,
                onClickEdit: () => onClickEdit({ record: { id }, routerPrefix })
            }), classStyle: 'm-1'
        }));
    }
    if (!viewOnly && id && isActive && has({ menuContext, key: 'canArchive' })) {
        col2.push(createButtonArchive({
            onClick: () => onClickArchive({
                record: { id },
                callArchive,
                setIsLoading: setIsLoadingApp,
                onClickView: () => onClickView({ record: { id }, routerPrefix })
            }), classStyle: 'm-1'
        }));
    }
    if (!viewOnly && id && isActive && has({ menuContext, key: 'canDelete' })) {
        col2.push(createButtonDelete({
            onClick: () => onClickDelete({
                record: { id },
                callDelete,
                setIsLoading: setIsLoadingApp,
                state: stateMenu[menuContext.id],
                routerPrefix
            }), classStyle: 'm-1'
        }));
    }
    return <Row type="flex">
        <Col>{col1}</Col>
        <Col class="ml-auto">{col2}</Col>
    </Row>;
};

export const onClickSave = ({ props, data, form = {} }) => {
    return data.useForm
        .validate()
        .then(() => {
            if (data?.useForm?.modelRef?.refLabAnalysisStatus?.key === 'Send Result') {
                Modal.confirm({
                    title: i18n.global.t('components.table.operatorAndPagination.youAreWant', { text: i18n.global.t('button.editAfterApprove') }),
                    autoFocusButton: 'cancel',
                    okType: 'danger',
                    onOk: () => {
                        return doSave({ props, data, form });
                    }
                });
            } else {
                return doSave({ props, data, form });
            }
        })
        .catch((error) => validateError({ error }));
};

export const doSave = ({ props, data, form = {} }) => {
    const { routerPrefix, viewOnly } = props;
    setIsLoadingApp(true);
    return callSave({ form: { ...data.useForm.modelRef, ...form } })
        .finally(() => setIsLoadingApp(false))
        .then((record) => {
            if (viewOnly) initForm({ props, data, isLayout: true });
            else onClickView({ record, routerPrefix });
        });
};

export const loadForm = ({ props, data }) => {
    setIsLoading(true);
    const { form } = props;
    const { id, useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else if (id) {
        promise = callSearch({ criteria: createSearchOneCriteria({ id }) });
    } else {
        promise = Promise.resolve({ data: [modelRef] });
    }
    return promise
        .then(page => initUseForm({ data, page }))
        .then(() => loadDefaultForm({ data }))
        .then(() => initRule({ props, data }))
        .finally(() => {
            setIsLoading(false);
        });
};

export const loadDefaultForm = ({ data }) => {
    const promises = [];
    promises.push(callLookupStatus().then(arr => {
        data.statuses = arr;
    }));
    promises.push(callRepeatOption({}).then(arr => {
        data.repeatOption = arr;
    }));
    return Promise.all(promises);
};

export const initRule = ({ data }) => {
    const { useForm } = data;
    const { modelRef } = useForm;
    watch(
        () => modelRef?.topics?.length,
        () => {
            clearRulesStartsWith({ useForm, key: `topics` });
            modelRef?.topics?.forEach((topic, index) => {
                if (!topic.id) {
                    addRules({ useForm, modelRef, key: `topics.${index}.refLabTopic`, rules: [required] });
                }
            });
        },
        { flush: 'post' }
    );
    watch(
        () => modelRef.refLabResultStatus,
        () => {
            const isReject = ['Reject', 'RejectCanRepeat'].includes(modelRef.refLabResultStatus?.key);
            clearRulesStartsWith({ useForm, key: `rejectRemark` });
            if (isReject) {
                addRules({ useForm, modelRef, key: `rejectRemark`, rules: [required] });
            }
        },
        { flush: 'post' }
    );
};

export const initForm = ({ props, data, isLayout }) => {
    const { routerPrefix } = props;
    checkAttribute({ props, data });
    data.form = createForm();
    data.rules = createRules();
    data.useForm = createUseForm(data.form, data.rules);
    data.fieldsSampling = createFields({ props, data });
    data.actionButtons = createActionButtons({ props, data });

    watch(
        () => data?.useForm?.modelRef?.refSamplingProduct?.refSamplingRequest?.refSamplingRequestType,
        () => {
            const refSamplingRequestType = data?.useForm?.modelRef.refSamplingProduct?.refSamplingRequest?.refSamplingRequestType;
            data.refSamplingRequestTypeKey = refSamplingRequestType?.key;
            data.fieldsSampling = createFields({ props, data, refSamplingRequestType });
        },
        { flush: 'post' }
    );

    data.fieldsAnalysis = createFieldsAnalysis({ props, data });
    data.fieldsAnalysisRemark = fieldsAnalysisRemark({ props, data });
    data.fetchCriteriaAnalysisTopic = {
        criteria: {
            select: ['**', 'refLabTopic.refLabFormula.*'],
            size: 1000,
            where: [{ name: 'refSamplingProductAnalysis.id', type: 'UUID', operator: '=', value: data.id }],
            sort: [{ name: 'refLabTopic.seq', type: 'ASC' }],
            children: [
                {
                    name: 'inputs',
                    select: ['*'],
                    size: 1000,
                    sort: [{ name: 'subSeq', type: 'ASC' }],
                    children: [
                        {
                            name: 'results',
                            select: ['*', 'refCountry.*', 'refResultStatus.*', 'refLabCountryStandardGroupTopicLabTopic.*'],
                            size: 1000,
                            sort: [{ name: 'createDate', type: 'ASC' }]
                        }
                    ]
                },
                {
                    name: 'transferTos',
                    select: [
                        '*',
                        'refLabTopic.*',
                        'refSamplingProductAnalysis.*',
                        'refSamplingProductAnalysis.refLabAnalysisStatus.*',
                        'refSamplingProductAnalysis.refDepartment.*',
                        'refSamplingProductAnalysis.refLabExt.*',
                        'refSamplingProductAnalysis.refLabType.*',
                        'refSamplingProductAnalysis.refExtCenterType.*'
                    ],
                    size: 1000,
                    sort: [{ name: 'createDate', type: 'ASC' }]
                }
            ]
        }
    };

    data.attachments = {
        fetchCriteria: {
            select: ['*'], page: 0, size: 1000,
            where: [
                { name: 'model', type: 'String', operator: '=', value: 'SamplingProductAnalysis' },
                { name: 'refId', type: 'UUID', operator: '=', value: data.id }
            ]
        }
    };
    const menuContextAttachments = lodash.cloneDeep(props.menuContext);
    const index = menuContextAttachments?.attribute?.indexOf('canView');
    if (index !== -1) {
        menuContextAttachments?.attribute.splice(index, 1);
    }
    if (menuContextAttachments?.attribute?.includes('canEdit')) {
        menuContextAttachments?.attribute.push('canCreate');
        menuContextAttachments?.attribute.push('canDelete');
    }
    data.menuContextAttachments = menuContextAttachments;
    initState({ props, data }).then(state => {
        loadForm({ props, data })
            .then(() => {
                if (props.setAppPageHeader) {
                    setAppPageHeader({
                        isHiddenBreadcrumb: !isLayout,
                        slots: {
                            top: () => createAppPageHeaderTop({
                                props,
                                data,
                                state: state,
                                routerPrefix,
                                onClickView,
                                onClickEdit
                            }),
                            default: () => createAppPageHeaderDefault({ props, data })
                        }
                    });
                }
            });
    });
};

export const stateMenu = reactive([]);

export const state = reactive({
    conditionReport: createConditionReport()
});